import { render, staticRenderFns } from "./level3IdSelect.vue?vue&type=template&id=b13170de&"
import script from "./level3IdSelect.vue?vue&type=script&lang=js&"
export * from "./level3IdSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports